var CategoryFilterModule = (function () {
    function CategoryFilterModule() {
    }
    CategoryFilterModule.forRoot = function () {
        return {
            ngModule: CategoryFilterModule,
            providers: [],
        };
    };
    return CategoryFilterModule;
}());
export { CategoryFilterModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/pipes/category-filter/category-filter.module.ts.pre-build-optimizer.js